<template>
    <div>
        personal
    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    methods:{

    }
}

</script>

<style scoped lang='scss'>

</style>
